import styled from 'styled-components';

const CommunicationDetailsSection = styled.div`
  border: 1px solid ${p => p.theme.color.border};
  border-radius: 6px;
  display: flex;
  .column {
    max-height: 250px;
    width: 33.333333333333333%;
    box-sizing: border-box;
    display: block;
    border-right: 1px solid ${p => p.theme.color.border};
    &:last-child {
      border-right: none;
    }
  }    
  .column-title {
    font-size: 1.5em;
    margin: 10px 16px;
    &+ .column-row{
      margin-top: 6px;
    }
  }
  .column-row {
    margin: 32px 16px;
    display: flex;
    flex-wrap: wrap;
    &>* {
      width: 100%;
    }
    &.small-margins {
      margin: 16px;
    }
    &.small-margin-bottom {
      margin-bottom: 26px;
    }
  }
  .half-row {
    width: 50%;
    box-sizing: border-box;
  }
  .campus-name {
    padding-left: 1em;
  }
  .message-description {
    overflow: hidden;
    position: relative; 
    line-height: 1.2em;
    max-height: 3.6em; 
    text-align: justify;  
    margin-right: -1em;
    padding-right: 1em;
    box-sizing: border-box;
    width: 100%;
  }
  .message-description:before {
    content: '...';
    position: absolute;
    right: 0;
    bottom: 0;
  }
  .message-description:after {
    content: '';
    position: absolute;
    right: 0;
    width: 1em;
    height: 1em;
    margin-top: 0.2em;
    background: white;
  }
  .get-more-details-btn {
    font-size: 1em;
    color: ${p => p.theme.color.primary};
    width: 100%;
    text-align: center;
    cursor: pointer;
    transition: .25s opacity ease-in-out;
    &:hover {
      opacity: .8;
    } 
  }
  .campus-name {
    white-space: initial;
  }
  .item-with-comma {
    &:after{
        content: ', '
      };
      &:last-of-type { 
        &:after{
          display: none
        };
      }
  }
  .messages-details-part {
    max-height: 6.5em;
    overflow: hidden;
    margin-top: -1em;
  }
`;

export default { CommunicationDetailsSection };